import React from 'react';

/**
 * TOCSlide - Slide 2: Table of contents (fixed template).
 */
const TOCSlide: React.FC = () => {
  const items = [
    { num: '00', title: '全体像', desc: '強みを「誰に・どんな気づきから・どう伝えるか」を戦略マップに落とし込みました', page: 'p.3' },
    { num: 'Step 1', title: 'USP：強みの整理', desc: '市場・競合・自社を分析し、他社には真似できないポジションを導き出しました', page: 'p.4\u20135' },
    { num: 'Step 2', title: 'WHO：届ける相手の整理', desc: 'ファネル別に、最も効果が見込める3つのセグメントを設定しました', page: 'p.6\u20137' },
    { num: 'Step 3', title: 'WHAT：伝え方の設計とバナーサンプル', desc: 'ターゲットのホンネから訴求戦略を設計し、バナーデザイン案に落とし込みました', page: 'p.8\u201314' },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="slide-hdr">
        <p className="sl">Contents</p>
        <h2>本レポートについて</h2>
      </div>
      <p style={{ fontSize: 'clamp(13px, 1.8vmin, 17px)', color: 'rgba(29,25,38,0.6)', lineHeight: 1.8, marginBottom: 'clamp(16px, 2.4vmin, 32px)' }}>
        この度は広告バナー制作のご依頼をいただき、誠にありがとうございます。<br />
        本レポートでは、御社サイトの分析をもとに、強みを「誰に・どう伝えるか」を戦略マップに整理し、<br />
        実際のバナーデザイン案までご提案しています。
      </p>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          {items.map((item, i) => (
            <div
              key={i}
              style={{
                borderTop: '1px solid #E0E0E0',
                padding: 'clamp(14px, 2vmin, 24px) 0',
                display: 'flex',
                alignItems: 'baseline',
                gap: 'clamp(16px, 2.4vmin, 24px)',
              }}
            >
              <span style={{ fontSize: 13, fontWeight: 700, fontFamily: 'Inter, sans-serif', color: 'rgba(29,25,38,0.4)', width: 72, flexShrink: 0 }}>
                {item.num}
              </span>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 'clamp(16px, 2.2vmin, 20px)', fontWeight: 700, marginBottom: 4 }}>{item.title}</p>
                <p style={{ fontSize: 'clamp(12px, 1.5vmin, 14px)', color: 'rgba(29,25,38,0.4)' }}>{item.desc}</p>
              </div>
              <span style={{ fontSize: 13, fontFamily: 'Inter, sans-serif', color: 'rgba(29,25,38,0.4)', marginLeft: 'auto', flexShrink: 0 }}>
                {item.page}
              </span>
            </div>
          ))}
          <div style={{ borderTop: '1px solid #E0E0E0' }} />
        </div>
      </div>
    </div>
  );
};

export default TOCSlide;
